import React, { useEffect, useState } from "react";
import add_icon from "../../assets/profile/add_icon.png";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import toast from "react-hot-toast";
const Address = () => {
  const [address, setAddress] = useState([]);
  const [addNewAddress, setAddNewAddress] = useState(false);
  const [showEditOption, setShoeEditOption] = useState(false);
  // ✅ Load from localStorage (only once)
  useEffect(() => {
    const storedAddress = localStorage.getItem("address");
    if (storedAddress) {
      setAddress(JSON.parse(storedAddress));
    }
  }, []);

  // ✅ Save to localStorage whenever address changes
  useEffect(() => {
    localStorage.setItem("address", JSON.stringify(address));
  }, [address]);

  // ✅ Handle form submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);

    const newAddress = {
      id: Date.now(), // unique id
      name: formData.get("name"),
      email: formData.get("email"),
      phone: formData.get("phone"),
      address_line_1: formData.get("address_line_1"),
      address_line_2: formData.get("address_line_2"),
      pincode: formData.get("pincode"),
      city: formData.get("city"),
      state: formData.get("state"),
      country: formData.get("country"),
      default: formData.get("defaultAddress") === "on",
    };

    // ✅ Ensure only ONE default address
    let updatedAddresses = [...address];

    if (newAddress.default) {
      updatedAddresses = updatedAddresses.map((addr) => ({
        ...addr,
        default: false,
      }));
    }

    setAddress([...updatedAddresses, newAddress]);
    toast.success("Address saved successfully")
    setAddNewAddress(false);
    e.target.reset();
  };
  const handleDelete = (id) => {
    const filtered = address.filter((addr) => addr.id !== id);
    setAddress(filtered);
    toast.success("Address removed successfully")
  };
  return (
    <div className="bg-white py-4 sm:px-4 px-6 flex flex-col rounded-[10px] sm:rounded-md ">
      <h2 className="font -semibold font-lexend xs:text-lg text-xl">Address</h2>

      {address.length > 0 ? (
        <div className="flex flex-col w-full gap-4 mt-4">
          {address.map((addr) => (
            <div
              key={addr.id}
              className="p-4 sm:p-2.5 bg-[#e9f6e8] border relative border-[#8dba93] rounded-[10px] sm:rounded-md "
            >
               <div className="flex justify-between items-center">
                <h3 className="sm:text-base text-xl font-lexend font-bold">
                  {addr.name}
                </h3>
                <div className="relative">
                  <button onClick={() => setShoeEditOption(!showEditOption)} aria-labelledby="option dots" className="">
                    <MoreVertIcon />
                  </button>
                  {showEditOption && (
                    <div onBlur={() => setShoeEditOption(false)} className="absolute  right-0 top-8 shadow-md w-32 text-left z-20 overflow-hidden  bg-white flex flex-col justify-start  text-sm items-start rounded-md">
                      <button onClick={() => setShoeEditOption(false)} className="w-full text-left px-3 hover:bg-gray-100 py-1.5 font-lexend ">
                        Edit
                      </button>
                      <button onClick={() => {setShoeEditOption(false); handleDelete(addr.id)}} className="w-full text-left px-3 hover:bg-gray-100 py-1.5 font-lexend ">
                        Remove
                      </button>
                      <button onClick={() => setShoeEditOption(false)} className="w-full text-left px-3 hover:bg-gray-100 py-1.5 font-lexend ">
                        Set as Default
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <p className="text-black sm:text-sm text-lg font-light font-lexend ">
                {addr.address_line_1} <br /> {addr.address_line_2}
              </p>
              <p className="text-black sm:text-sm text-lg font-light font-lexend">
                Phone Number: {addr.phone}
              </p>
              <p className="text-black sm:text-sm text-lg font-light font-lexend">
                Email: {addr.email}
              </p>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex justify-center items-center md:h-40 h-40 sm:h-28 text-center w-full mt-4">
          <p className="font-lexend text-xl sm:text-sm ">
            No addresses found. Please add a new address.
          </p>
        </div>
      )}

      <button
        onClick={() => {
          setAddNewAddress(true);
        }}
        className={` ${addNewAddress ? "bg-[#bad7b9] text-white cursor-not-allowed" : "bg-[#2a552f] text-[#f4e390] cursor-pointer"} w-full flex justify-center items-center gap-3 xs:text-base  text-xl font-lexend py-2 md:px-11 rounded-lg sm:mt-4 mt-6`}
      >
        <img src={add_icon} alt="add icon" /> Add new address
      </button>
      {addNewAddress && (
        <form
          onSubmit={(e) => handleSubmit(e)}
          className="sm:mt-1 mt-8 sm:text-sm text-lg"
          action=""
        >
          <input
            type="text"
            name="name"
            placeholder="First Name *"
            className="w-full border placeholder:font-lexend placeholder:text-[#a2a19f] font-lexend border-[#b1b1b1] rounded-[10px]  sm:rounded-md sm:py-2 sm:px-3 py-2 px-4  mt-4 outline-none focus:border-[#2a552f]"
          />
          <input
            type="email"
            name="email"
            placeholder="Email Address *"
            className="w-full border placeholder:font-lexend placeholder:text-[#a2a19f] font-lexend border-[#b1b1b1] rounded-[10px] sm:rounded-md  sm:py-2 sm:px-3 py-2 px-4  mt-4 outline-none focus:border-[#2a552f]"
          />
          <input
            type="text"
            name="phone"
            placeholder="Phone Number *"
            className="w-full border placeholder:font-lexend placeholder:text-[#a2a19f] font-lexend border-[#b1b1b1] rounded-[10px] sm:rounded-md  sm:py-2 sm:px-3 py-2 px-4  mt-4 outline-none focus:border-[#2a552f]"
          />
          <input
            type="text"
            name="address_line_1"
            placeholder="Address (Line 1)*"
            className="w-full border placeholder:font-lexend placeholder:text-[#a2a19f] font-lexend border-[#b1b1b1] rounded-[10px] sm:rounded-md  sm:py-2 sm:px-3 py-2 px-4  mt-4 outline-none focus:border-[#2a552f]"
          />
          <input
            type="text"
            name="address_line_2"
            placeholder="Address (Line 2)"
            className="w-full border placeholder:font-lexend placeholder:text-[#a2a19f] font-lexend border-[#b1b1b1] rounded-[10px] sm:rounded-md  sm:py-2 sm:px-3 py-2 px-4  mt-4 outline-none focus:border-[#2a552f]"
          />
          <div className="flex flex-row items-center gap-4">
            <input
              type="text"
              name="pincode"
              placeholder="Pincode*"
              className="w-full border placeholder:font-lexend placeholder:text-[#a2a19f] font-lexend border-[#b1b1b1] rounded-[10px] sm:rounded-md  sm:py-2 sm:px-3 py-2 px-4  mt-4 outline-none focus:border-[#2a552f]"
            />{" "}
            <input
              type="text"
              name="city"
              placeholder="City*"
              className="w-full border placeholder:font-lexend placeholder:text-[#a2a19f] font-lexend border-[#b1b1b1] rounded-[10px] sm:rounded-md  sm:py-2 sm:px-3 py-2 px-4  mt-4 outline-none focus:border-[#2a552f]"
            />
          </div>
          <div className="flex flex-row items-center gap-4">
            <input
              type="text"
              name="state"
              placeholder="State*"
              className="w-full border placeholder:font-lexend placeholder:text-[#a2a19f] font-lexend border-[#b1b1b1] rounded-[10px] sm:rounded-md  sm:py-2 sm:px-3 py-2 px-4  mt-4 outline-none focus:border-[#2a552f]"
            />{" "}
            <input
              type="text"
              name="country"
              placeholder="Country*"
              className="w-full border placeholder:font-lexend placeholder:text-[#a2a19f] font-lexend border-[#b1b1b1] rounded-[10px] sm:rounded-md  sm:py-2 sm:px-3 py-2 px-4  mt-4 outline-none focus:border-[#2a552f]"
            />
          </div>

          <div className="flex justify-between flex-row items-center md:pt-0 pt-4 md:mt-6 sm:mt-0 mt-3">
            <div className="flex flex-row justify-center items-center">
              <input
                type="checkbox"
                id="defaultAddress"
                name="defaultAddress"
                className="mr-2 cursor-pointer"
              />
              <label
                htmlFor="defaultAddress"
                className="font-lexend cursor-pointer xs:text-xs text-[#a2a19f] text-base border-[#b1b1b1]"
              >
                Make default address
              </label>
            </div>
            <button className="bg-[#2a552f] text-[#f4e390] sm:text-base  text-xl font-lexend py-2 px-11 sm:px-6 rounded-lg ">
              Save
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default Address;
